import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="animate-fade-in pt-10 text-center" data-testid="payment-cancel-page">
      <XCircle size={48} className="mx-auto text-[color:var(--ivoire-muted)]" />
      <h1 className="mt-6 font-serif text-2xl text-[color:var(--ivoire)]">Paiement annulé</h1>
      <p className="mt-3 text-sm text-[color:var(--ivoire-muted)]">Aucun montant n'a été prélevé.</p>
      <div className="mt-8 grid gap-3 max-w-xs mx-auto">
        <Link data-testid="cancel-retry" to="/premium" className="h-14 flex items-center justify-center rounded-2xl bg-[color:var(--sauge)] text-[color:var(--bg-deep)] font-medium">
          Reprendre l'abonnement
        </Link>
        <Link data-testid="cancel-home" to="/" className="h-14 flex items-center justify-center rounded-2xl border border-[color:var(--border)] text-[color:var(--ivoire)]">
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}
